const setActiveSurveysAction = async ({ commit }, payload) => {
  commit('setActiveSurveys', payload)
}

export default {
  setActiveSurveysAction,
}
